import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import { authorize } from './../../ducks/auth';

// Простые SVG иконки для показа/скрытия пароля
const VisibilityIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
  </svg>
);

const VisibilityOffIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
  </svg>
);

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      login: '',
      password: '',
      error: false,
      errorMessage: '',
      showPassword: false,
    };

    this.login = this.login.bind(this);
    this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };
  async login(event) {
    event.preventDefault();
    if (this.state.login.length === 0 || this.state.password.length === 0) {
      this.setState({ error: true, errorMessage: 'Логин и пароль обязательны' });
      return false;
    }

    try {
      await this.props.authorize(this.state.login.trim(), this.state.password);
      this.props.history.push('/');
    } catch (err) {
      console.error('Ошибка входа:', err);
      const errorMessage = err.message || 'Неправильные логин или пароль';
      this.setState({ error: true, errorMessage });
    }
  }
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <Paper className={classes.loginPaper} elevation={2}>
          <form onSubmit={event => this.login(event)}>
            <Typography variant="h5">Вход</Typography>
            <TextField
              id="login"
              value={this.state.login}
              label="Логин"
              fullWidth
              margin="normal"
              onChange={event => this.setState({ login: event.target.value })}
            />
            <TextField
              id="password"
              value={this.state.password}
              label="Пароль"
              margin="normal"
              fullWidth
              onChange={event => this.setState({ password: event.target.value })}
              type={this.state.showPassword ? 'text' : 'password'}
              helperText={this.state.error ? this.state.errorMessage : undefined}
              error={this.state.error}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="переключить видимость пароля"
                      onClick={this.handleClickShowPassword}
                      edge="end"
                    >
                      {this.state.showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <div className={classes.submitContainer}>
              <Button variant="contained" color="primary" type="submit" fullWidth>
                Вход
              </Button>
            </div>
            <div className={classes.registrationLink}>
              <Button
                variant="text"
                color="primary"
                onClick={() => this.props.history.push('/register')}
                fullWidth
              >
                Регистрация менеджера
              </Button>
            </div>
            {this.props.location.search.includes('emailConfirmed=true') && (
              <Typography variant="body2" color="primary" style={{ marginTop: 10, textAlign: 'center' }}>
                Email подтвержден! Войдите в систему.
              </Typography>
            )}
          </form>
        </Paper>
      </div>
    );
  }
}

const styles = () => ({
  container: {
    display: 'flex',
    flex: 1,
    width: '100%',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    padding: 16,
  },
  loginPaper: {
    width: '100%',
    maxWidth: 400,
    padding: 30,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  submitContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 20,
  },
  registrationLink: {
    marginTop: 15,
    textAlign: 'center',
  },
});

const Styled = withStyles(styles)(Login);

export default connect(() => ({}), { authorize })(Styled);
